import useAtmosphere, { AtmosphereVariables } from 'hooks/useAtmosphere'
import { useLogger } from 'hooks/useLogger'
import { useCallback } from 'react'
import { SignalData } from 'simple-peer'

import { LocalVideocallParticipant } from '../model-videochamada'

export interface WebRtcSignal {
  sender: LocalVideocallParticipant
  receiverId: ID
  data: SignalData
}

export type SendSignalCallback = (receiverId: ID, signal: SignalData) => void

interface WebRtcSignalingServerOptions extends Omit<AtmosphereVariables<WebRtcSignal>, 'topic' | 'onMessage'> {
  selfData: LocalVideocallParticipant
  roomId: ID
  onSignal(signal: WebRtcSignal, sendSignal: SendSignalCallback): void
}

type PushCallback = (message: WebRtcSignal) => void
const pushSignalProxy = (push: PushCallback, sender: LocalVideocallParticipant) => (
  receiverId: ID,
  signal: SignalData
) => {
  push({ receiverId, sender: sender, data: signal })
}
export function useWebRtcSignalingServer({ selfData, roomId, onSignal, ...rest }: WebRtcSignalingServerOptions) {
  const logger = useLogger()

  const handleMessage = useCallback(
    (message: WebRtcSignal | string, _, push: PushCallback) => {
      const parsedMessage: WebRtcSignal = typeof message === 'string' ? (JSON.parse(message) as WebRtcSignal) : message

      // TODO: @RNG Otimizar para não enviar todas as mensagens para todos sempre (#14543)
      if (selfData && selfData.id === parsedMessage.receiverId && onSignal)
        onSignal(parsedMessage, pushSignalProxy(push, selfData))
    },
    [onSignal, selfData]
  )

  const { push } = useAtmosphere<WebRtcSignal>({
    topic: `public/webRtcSignal/${roomId}`,
    onMessage: handleMessage,
    ...rest,
  })

  const sendSignal = useCallback<SendSignalCallback>(
    (receiverId, signal) => {
      logger.info('Enviando sinal de conexão a Peer')
      push({ receiverId, sender: selfData, data: signal })
    },
    [push, selfData, logger]
  )

  return {
    sendSignal,
  }
}
